var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Interfaces = OCS.WxBriefing.Interfaces || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Functions.define_desktop_vertical_menu_interface = function () {
    return {
        activate: function (request) {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu({keep_submenu: true});
            this.parent();
            var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
            drop_window.position(this.element).content(this.ul_element.clone()).show();
        },
        deactivate: function () {
            this.parent();
            var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
            drop_window.hide();
        }
    };
};
OCS.WxBriefing.Interfaces.DesktopVerticalMenu = OCS.WxBriefing.Functions.define_desktop_vertical_menu_interface();